import React from 'react';
import ContactBlock from './ContactBlock';

export const teamMembers = [
  {
    name: 'Quaidjohar Hatim',
    role: 'CEO & Founder',
    location: 'Pakistan',
    featured: true,
    website: null,
  },
  {
    name: 'Juzer Quaidjohar',
    role: 'Director & Head of Sales',
    location: 'United Kingdom',
    featured: false,
    website: null,
  },
  {
    name: 'Huzaifa Mustafa',
    role: 'Digital Partner',
    location: 'Pakistan',
    featured: false,
    website: 'https://huzaifamustafa.com',
  },
  {
    name: 'Murtaza Yousuf Ali',
    role: 'Farm Operations Manager',
    location: 'Uganda',
    featured: false,
    website: null,
  },
  {
    name: 'Mustafa Murtaza',
    role: 'Assistant Manager (Farm & Media)',
    location: 'Uganda',
    featured: false,
    website: null,
  },
];

export default function TeamAndContact() {
  return (
    <section id="team" className="relative py-20 lg:py-28">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-20 lg:mb-28">
            <div className="lg:col-span-4">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-4">Our Team</p>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-gray-900 mb-6">
                The people behind the coffee
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Led by founder Quaidjohar Hatim, who brings five decades of business experience. The team works across Uganda, Pakistan and the United Kingdom.
              </p>
            </div>

            <ul className="lg:col-span-8 divide-y divide-gray-300/70 border-y border-gray-300/70">
              {teamMembers.map((member) => (
                <li key={member.name} className="grid grid-cols-1 sm:grid-cols-12 gap-1 sm:gap-6 py-6 sm:items-baseline">
                  <div className="sm:col-span-5">
                    {member.featured && (
                      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-1">Founder</p>
                    )}
                    <h3 className={`font-heading text-gray-900 ${member.featured ? 'text-3xl' : 'text-2xl'}`}>{member.name}</h3>
                  </div>
                  <div className="sm:col-span-4">
                    <p className="text-gray-700">{member.role}</p>
                    {member.website && (
                      <a href={member.website} target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-clay hover:text-clay/80 transition-colors">
                        {member.website.replace('https://', '')} <span aria-hidden="true">&rarr;</span>
                      </a>
                    )}
                  </div>
                  <p className="sm:col-span-3 sm:text-right text-sm text-gray-500">{member.location}</p>
                </li>
              ))}
            </ul>
          </div>

          <div id="contactus">
            <div className="mb-10">
              <h3 className="font-heading text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-gray-900 mb-4">
                Let's connect
              </h3>
              <p className="text-lg text-gray-700 max-w-2xl leading-relaxed">
                Questions about the coffee, a partnership, or a farm visit? Get in touch.
              </p>
            </div>

            <ContactBlock />
          </div>
        </div>
      </div>
    </section>
  );
}
